import { lowerCase } from '~/utils/utils'

export default function toLowerCaseFilter (string) {
  return lowerCase(string)
}
